import React, { useState, useEffect } from "react";
import Fotter from "../components/Fotter";
import Navbar from "../components/Navbar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./ListAnItem.css";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { BASE_URL } from "./Config";
import Swal from "sweetalert2";
import Select from "react-select";
import imageCompression from "browser-image-compression";

// पुराना:
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

// नया:
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

export default function ListAnItem() {
  const [loading, setLoading] = useState(false); // Loading state
  const [step, setStep] = useState(() => {
    const savedStep = localStorage.getItem("listItemStep");
    return savedStep ? parseInt(savedStep) : 1;
  });

  const [sessionuser, setUser] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const compressImage = async (file) => {
    const options = {
      maxSizeMB: 1, // compress to around 1MB
      maxWidthOrHeight: 1280,
      useWebWorker: true,
    };
    return await imageCompression(file, options);
  };

  const [preview, setPreview] = useState([]);
  const [imagelodaer, setImageLoading] = useState(false);
  const handleFiles = (files) => {
    let fileArray = Array.from(files);

    if (fileArray.length > 5) {
      fileArray = fileArray.slice(0, 5);
      alert("You can upload a maximum of 5 images.");
    }

    setImageLoading(true);

    setPreview(fileArray.map((f) => URL.createObjectURL(f)));
    updateFormData2(fileArray);

    setImageLoading(false);
  };

  const [MembershipPlan, setMembershipPlan] = useState(null);

  // const userName = Cookies.get("username");
  const user_id = Cookies.get("user_id");

  function reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  }

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    setImageLoading(true); // 🟡 Loader Start

    const items = reorder(
      formData.photos,
      result.source.index,
      result.destination.index
    );

    setFormData({ ...formData, photos: items });

    setImageLoading(false); // 🟢 Loader End
  };

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_user_by_id.php?id=${user_id}&t=${Date.now()}`)
      .then((res) => {
        /// console.log("API response:", res); // Check the full response
        if (res.data.success) {
          setUser(res.data.data);
          setMembershipPlan(res.data.data.membership_type);
        } else {
          console.error("API response error:", res.data.message);
        }
      })
      .catch((err) => {
        console.error("API request failed:", err);
        if (err.response) {
          console.error("Response error:", err.response);
        } else if (err.request) {
          console.error("No response received:", err.request);
        } else {
          console.error("Request setup error:", err.message);
        }
      });
  }, []);

  const defaultFormData = {
    title: "",
    category: "",
    city: "",
    shortDesc: "",
    desc: "",
    auctionStartPrice: "",
    desiredPrice: "",
    listingType: "",
    closingTime: "",
    buyNow: "",
    productType: "",
    useproductDes: "",
    shipping: "",
    // shippingCity: "",
    // shippingCost: "",
    // sheppingDes: "",
    // freeshipping: "",
    photos: [],
  };
  useEffect(() => {
    const saved = localStorage.getItem("listItemData");
    const savedStep = localStorage.getItem("listItemStep");

    if (saved) {
      const parsed = JSON.parse(saved);

      // Check if ANY field is non-empty (excluding purely optional fields like photos)

      const hasData = Object.entries(parsed).some(
        ([key, value]) => typeof value === "string" && value.trim() !== ""
      );

      if (hasData) {
        Swal.fire({
          title: "Resume Previous Data?",
          text: "We found a saved form. Do you want to continue where you left off?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes, continue",
          cancelButtonText: "No, start fresh",
        }).then((result) => {
          if (result.isConfirmed) {
            setFormData(parsed); // Load saved data
            setStep(savedStep ? parseInt(savedStep, 10) : 1); // Load saved step
            setAcceptTerms(true)
            if (parsed.image && parsed.image.length > 0) {
              setPreviewImages(parsed.image); // Restore preview images from saved data
            }
          } else {
            setFormData(defaultFormData); // Reset form
            setStep(1); // Reset step
            localStorage.removeItem("listItemData"); // Clear saved data
            localStorage.removeItem("listItemStep"); // Clear saved step
          }
          setFormErrors({});
          setFormTouched({});
        });
      } else {
        // All fields empty
        setFormData(defaultFormData);
        setFormErrors({});
        setFormTouched({});
        setStep(1);
      }
    } else {
      // No saved data
      setFormData(defaultFormData);
      setFormErrors({});
      setFormTouched({});
      setStep(1);
    }
  }, []);

  const [formData, setFormData] = useState(() => {
    const saved = localStorage.getItem("listItemData");
    return saved
      ? JSON.parse(saved)
      : {
        user_id: "",
        username: "",
        title: "",
        category: "",
        shortDesc: "",
        useproductDes: "",
        desc: "",
        quantity: "",
        location: "",
        city: "",
        neighborhood: "",
        listingType: "",
        productType: "",
        auctionStartPrice: "",
        desiredPrice: "",
        buyNow: "",
        closingTime: "",
        closingTimeword: "",
        shipping: "",
        // shippingCity: "",
        // shippingCost: "",
        // sheppingDes: "",
        // freeshipping: "",
        photos: [],
        // image: [],
      };
  });

  useEffect(() => {
    localStorage.setItem("listItemData", JSON.stringify(formData));
  }, [formData]);

  useEffect(() => {
    localStorage.setItem("listItemStep", step);
  }, [step]);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewImages, setPreviewImages] = useState(formData.photos || []);

  const [suggestions, setSuggestions] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [formTouched, setFormTouched] = useState({});

  const base64ToFile = (base64, filename) => {
    const arr = base64.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const updateFormData = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
    setFormTouched((prev) => ({ ...prev, [key]: true }));

    if ((value || "").toString().trim() !== "") {
      setFormErrors((prev) => ({ ...prev, [key]: null }));
    }
  };

  const isMobile =
    /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(
      navigator.userAgent
    );

  let updateFormData2;

  if (isMobile) {
    updateFormData2 = async (files) => {
      const incoming = Array.from(files);
      const newImages = [];

      for (let file of incoming) {
        if (!file || !file.size) continue;

        // Fix empty file.type
        if (!file.type || file.type === "") {
          file = new File([file], file.name || "image.jpg", {
            type: "image/jpeg",
          });
        }

        // Convert HEIC → JPEG
        if (file.type.includes("heic") || file.name.endsWith(".heic")) {
          try {
            file = await imageCompression(file, {
              fileType: "image/jpeg",
              maxWidthOrHeight: 1280,
            });
          } catch (e) {
            console.log("HEIC conversion failed", e);
          }
        }

        let compressedBlob = file;

        // 🔥 Compress to 50 KB
        try {
          compressedBlob = await imageCompression(file, {
            maxSizeMB: 0.05, // 50 KB
            maxWidthOrHeight: 1000,
            maxIteration: 10,
            useWebWorker: true,
          });
        } catch (e) {
          console.log("Compression failed:", e);
        }

        // Skip if still too big
        if (compressedBlob.size > 50 * 1024) {
          console.log(`SKIPPED: still > 50KB (${compressedBlob.size} bytes)`);
          continue;
        }

        // 🔥 REAL FIX: Convert Blob → File (MOBILE NEEDS THIS)
        const compressedFile = new File(
          [compressedBlob],
          file.name || "image.jpg",
          { type: "image/jpeg" }
        );

        const previewURL = URL.createObjectURL(compressedFile);

        newImages.push({
          file: compressedFile, // <-- REAL FILE (WORKS IN BACKEND)
          preview: previewURL,
        });
      }

      setFormData((prev) => {
        const prevPhotos = Array.isArray(prev.photos) ? prev.photos : [];
        return {
          ...prev,
          photos: [...prevPhotos, ...newImages].slice(0, 5),
        };
      });
    };
  } else {
    updateFormData2 = async (files) => {
      const incomingFiles = Array.from(files);

      const newImages = await Promise.all(
        incomingFiles.map(async (file) => ({
          file,
          preview: URL.createObjectURL(file),
          base64: await fileToBase64(file),
        }))
      );

      // ➕ append previous + new
      setFormData((prev) => ({
        ...prev,
        photos: [...(prev.photos || []), ...newImages].slice(0, 5),
      }));
    };
  }

  // -------------------------------------------------------------
  // ❌ Remove Image
  // -------------------------------------------------------------
  const removeImage = (index) => {
    setFormData((prev) => {
      const updatedPhotos = (prev.photos || []).filter((_, i) => i !== index);
      return { ...prev, photos: updatedPhotos };
    });

    setPreviewImages((prev) => prev.filter((_, i) => i !== index));
  };

  // ✅ Automatic localStorage update (sirf yaha hoga)
  useEffect(() => {
    const safeData = { ...formData };
    delete safeData.photos;

    localStorage.setItem("listItemData", JSON.stringify(safeData));
  }, [formData]);

  const nextStep = () => {
    const errors = {};

    // if (step === 1) {
    //   if (!acceptTerms) {
    //     toast.warning("Please accept Terms & Conditions to continue.");
    //     errors.acceptterms = "Please accept Terms & Conditions to continue.";
    //     return;
    //   }
    // }
    if (step === 1) {
      if (!formData.title) {
        errors.title = "Item title is required";
      } else if (formData.title.length < 2) {
        errors.title = "Title must not be less than 2 characters.";
      }
      if (formData.title.length > 50) {
        errors.title = "Title must not be more than 50 characters.";
      }

      if (!formData.location?.trim()) {
        errors.location = "Location is required";
      }
    }

    if (step === 2) {
      const start = parseFloat(formData.auctionStartPrice);
      const desired = parseFloat(formData.desiredPrice);

      if (!isNaN(desired) && !isNaN(start)) {
        const minDesired = start + start * 0.1;
        if (desired < minDesired) {
          errors.desiredPrice = `Desired price must be at least 10% more than start price (${minDesired.toFixed(
            2
          )} SAR)`;
        }
      }

      if (!formData.listingType) {
        setFormErrors((prev) => ({
          ...prev,
          listingType: " Please select a listing type. *",
        }));
        setFormTouched((prev) => ({ ...prev, listingType: true }));
        scrollToError("listingType");
        return;
      } else {
        setFormErrors((prev) => ({ ...prev, listingType: "" }));
      }

      if (!formData.closingTime.trim()) {
        errors.closingTime = "Closing Time is required";
      }

      if (sessionuser?.membership_type != "Basic") {
        const today = new Date().toISOString().split("T")[0];
        if (formData.closingTime < today) {
          errors.closingTime = "Closing Time cannot be in the past";
        }
      }

      if (formData.listingType === "Auctionwithbuy") {
        const desired = parseFloat(formData.desiredPrice);
        const buyNow = parseFloat(formData.buyNow);

        if (!formData.buyNow.trim()) {
          errors.buyNow = "Buy Now price is required";
        } else if (!isNaN(desired) && !isNaN(buyNow)) {
          if (buyNow <= desired) {
            errors.buyNow = `Buy Now price must be greater than desired price (${desired.toFixed(
              2
            )} SAR)`;
          }
        }
      }

      if (!formData.productType) {
        setFormErrors((prev) => ({
          ...prev,
          productType: " Please select a Product type. *",
        }));
        setFormTouched((prev) => ({ ...prev, productType: true }));
        scrollToError("productType");
        return;
      } else {
        setFormErrors((prev) => ({ ...prev, productType: "" }));
      }
    }

    // if (step === 3) {
    //   if (formData.shipping === "Yes") {
    //     if (!formData.shippingCity) {
    //       errors.shippingCity = "Shipping City is required";
    //     }

    //     if (!formData.shippingCost) {
    //       errors.shippingCost = "Shipping Cost is required";
    //     }
    //   }
    // }

    // If errors exist, block next step
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);

      const touchedFields = {};
      Object.keys(errors).forEach((field) => {
        touchedFields[field] = true;
      });
      setFormTouched((prev) => ({ ...prev, ...touchedFields }));

      // Scroll to the first error field
      const firstErrorField = Object.keys(errors)[0];
      scrollToError(firstErrorField);

      return;
    }

    if (step < 4) setStep(step + 1);
  };

  const prevStep = () => {
    if (step > 1) setStep(step - 1);
  };

  // Utility to scroll to an error field
  const scrollToError = (fieldName) => {
    // Try to find by name or id
    const el =
      document.querySelector(`[name="${fieldName}"]`) ||
      document.getElementById(fieldName);

    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      el.focus();
    }
  };

  // useEffect(() => {
  //   axios
  //     .get(
  //       `https://fasttrade.com.sa/testauction/get_membership.php?id=17&t=${Date.now()}`
  //     )
  //     .then((res2) => {
  //       console.log("Raw Response:", res2); // full object
  //       console.log("Full API response:", res2.data); // JSON body
  //       if (res2.data.success) {
  //         setMembershipPlan(res2.data.active);
  //         console.log("Plan Detail:", res2.data.active);
  //       } else {
  //         console.error("Membership fetch error:", res2.data.message);
  //       }
  //     })
  //     .catch((err2) => {
  //       console.error("Membership fetch failed:", err2);
  //       if (err2.response) {
  //         console.error("Server responded with:", err2.response.data);
  //       }
  //     });
  // }, [user_id]);

  const handleSubmit = async () => {
    // if (!formData.main_image || formData.main_image.length === 0) {
    //   toast.warning("Main Image Required !");
    //   return; // ⛔ stop function here
    // }

    setLoading(true);

    const user_id = Cookies.get("user_id");

    if (!user_id || user_id.trim() === "") {
      navigate("/login");
      setLoading(false);
      return;
    }

    // console.log("User_id :", user_id);

    // ✅ Check product limit based on membership
    try {
      const res = await fetch(
        `${BASE_URL}/check_membership_limit.php?user_id=${user_id}&t=${Date.now()}`
      );

      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }

      const data = await res.json();

      if (!data.success) {
        Swal.fire({
          icon: "error",
          title: "Oops!",
          text: "Something went wrong. Please try again.",
          confirmButtonColor: "#f27474",
        });
        setLoading(false);
        return;
      }

      console.log("plan", MembershipPlan);
      // MembershipPlan will be the full object fetched via axios
      if (!MembershipPlan) {
        Swal.fire({
          icon: "error",
          title: "Membership Plan Missing",
          text: "Unable to verify membership plan. Please try again.",
        });
        setLoading(false);
        return;
      }
      const membershipTitle = (MembershipPlan.title || "").trim();
      const itemLimit = parseInt(MembershipPlan.item_limit, 10);
      const activeCount = parseInt(data.active_products, 10);

      console.log("Membership:", membershipTitle);
      console.log("Limit:", itemLimit);
      console.log("Active Products:", activeCount);

      if (!isNaN(itemLimit)) {
        const usagePercent = (activeCount / itemLimit) * 100;

        if (usagePercent >= 60 && usagePercent < 100) {
          setLoading(false);

          const result = await Swal.fire({
            icon: "info",
            title: "Membership Usage Alert",
            html: `You have used <strong>${activeCount}</strong> out of <strong>${itemLimit}</strong> active products for your <strong>${membershipTitle}</strong> membership.<br/>Consider upgrading your membership soon.`,
            showCancelButton: true,
            confirmButtonText: "Upgrade Membership",
            cancelButtonText: "Continue",
            confirmButtonColor: "#f4b74d",
            cancelButtonColor: "#3085d6",
          });

          if (result.isConfirmed) {
            window.location.href = "/Subscription";
            return; // stop further processing if upgrading
          }
          // else continue...
        } else if (activeCount >= itemLimit) {
          setLoading(false);

          const result = await Swal.fire({
            icon: "warning",
            title: "Membership Limit Reached",
            html: `Your <strong>${membershipTitle}</strong> membership allows only <strong>${itemLimit}</strong> active products.<br/>Please upgrade your membership or remove existing items.`,
            showCancelButton: true,
            confirmButtonText: "Upgrade Membership",
            cancelButtonText: "Close",
            confirmButtonColor: "#f4b74d",
            cancelButtonColor: "#3085d6",
          });

          if (result.isConfirmed) {
            window.location.href = "/Subscription";
          }

          return; // stop further processing
        }
      }

      // Continue with your main processing here

      // Continue with the rest of your processing here
    } catch (error) {
      console.error("Membership check failed:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error checking membership. Please try again later.",
        confirmButtonColor: "#f27474",
      });
      setLoading(false);
    }

    // try {
    //   const res = await fetch(
    //     `https://upsalon.in/bsi/testauction/check_charges_pending.php?user_id=${user_id}&t=${Date.now()}`
    //   );
    //   const data = await res.json();

    //   if (!data.success) {
    //     alert("Something went wrong. Please try again.");
    //     setLoading(false);
    //     return;
    //   }

    //   console.log("charges of Users", data);

    //   const activeCount = data.active_products;

    //   console.log("charges_pending", activeCount);

    //   if (activeCount > 3) {
    //     Swal.fire({
    //       icon: "warning",
    //       title: "Pending Payment",
    //       text: "The charges for the products you have won are still pending. Please complete the payment before making the products live.",
    //       confirmButtonColor: "#f4b74d",
    //     });
    //     setLoading(false);
    //   }
    // } catch (error) {
    //   console.error("Membership check failed", error);
    //   alert("Error checking membership.");
    //   setLoading(false);
    //   return;
    // }

    // if (!formData.photos || formData.photos.length === 0) {
    //   alert("Please select at least one image.");
    //   setLoading(false);
    //   return;
    // }

    // ==========================
    // Calculate closingTimeValue (in UTC)
    // ==========================
    let closingTimeValue;
    let selected = formData.closingTime;
    let now = new Date();

    if (
      sessionuser?.membership_type === "Silver" ||
      sessionuser?.membership_type === "Gold"
    ) {
      // Date from date picker
      if (selected) {
        // Date picker से आया हुआ value को UTC ISO में बदले
        closingTimeValue = new Date(selected).toISOString();
      }
    } else {
      // Dropdown relative time
      if (selected === "3min") {
        now.setMinutes(now.getMinutes() + 3);
      } else if (selected === "1min") {
        now.setMinutes(now.getMinutes() + 1);
      } else if (selected === "10min") {
        now.setMinutes(now.getMinutes() + 10);
      } else {
        const numDays = parseInt(selected);
        if (!isNaN(numDays)) {
          now.setDate(now.getDate() + numDays);
        } else {
          setFormData((prev) => ({
            ...prev,
            closingTime: "",
          }));
          setLoading(false);
          return;
        }
      }

      // Always send in UTC format
      if (!closingTimeValue) {
        closingTimeValue = now.toISOString(); // ✅ यह हमेशा UTC भेजेगा
      }
    }

    // ==========================
    // Build FormData
    // ==========================
    const sendData = new FormData();

    // Append all NON-photo fields
    for (const key in formData) {
      if (key === "photos") continue;

      if (Array.isArray(formData[key])) {
        formData[key].forEach((val, i) => sendData.append(`${key}[${i}]`, val));
      } else {
        sendData.append(key, formData[key]);
      }
    }

    // (formData.main_image || []).forEach((imgObj) => {
    //   sendData.append("main_image[]", imgObj.file);
    // });
    // Append photos correctly
    formData.photos.forEach((item) => {
      if (typeof item === "string") {
        // Old image from database
        sendData.append("photos[]", item);
      } else {
        // New file uploaded
        sendData.append("photos[]", item.file);
      }
    });

    // Debug;
    // for (let pair of sendData.entries()) {
    //   console.log(pair[0] + ": ", pair[1]);
    // }

    sendData.append("user_id", user_id);
    sendData.append("closingTime", closingTimeValue);
    try {
      const res = await fetch(`${BASE_URL}/list-item.php`, {
        method: "POST",
        body: sendData,
      });

      const result = await res.text();
      console.log(result);

      Swal.fire({
        icon: "success",
        title: "<h3 style='color:#28a745; font-weight:bold;'>🎉 Success!</h3>",
        html: `
    <p style="font-size:16px; color:#333; margin:8px 0;">
      Your item is now <b style="color:#28a745;">Live</b> 🚀
    </p>
    <p style="font-size:14px; color:#666; margin:0;">
      Buyers can now view and place bids on it.
    </p>
  `,
        background: "linear-gradient(135deg, #f0fff4, #d4edda)",
        confirmButtonColor: "#28a745",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      toast.success("Item Live Successfully!");
      localStorage.removeItem("listItemData");
      localStorage.removeItem("listItemStep");
      navigate("/");
    } catch (error) {
      console.error("Upload failed", error);
      alert("Upload failed!");
    }

    setLoading(false);
  };

  const handleSaveDraft = async () => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "You want to save as draft!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Save it!",
    });

    if (!confirm.isConfirmed) return;

    setLoading(true);

    const user_id = Cookies.get("user_id");
    if (!user_id || user_id.trim() === "") {
      navigate("/login", { state: { from: location } });
      setLoading(false);
      return;
    }

    // 🟢 Closing time optional bana do
    let closingTimeValue = "";
    let selected = formData.closingTime;
    let now = new Date();

    if (selected) {
      if (["Silver", "Gold"].includes(sessionuser?.membership_type)) {
        closingTimeValue = new Date(selected)
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
      } else {
        if (selected === "3min") now.setMinutes(now.getMinutes() + 3);
        else if (selected === "1min") now.setMinutes(now.getMinutes() + 1);
        else if (selected === "10min") now.setMinutes(now.getMinutes() + 10);
        else {
          const numDays = parseInt(selected);
          if (!isNaN(numDays)) now.setDate(now.getDate() + numDays);
        }
        closingTimeValue = now.toISOString().slice(0, 19).replace("T", " ");
      }
    }

    // 🟢 Build FormData
    const sendData = new FormData();

    // Append all NON-photo fields
    for (const key in formData) {
      if (key === "photos") continue;

      if (Array.isArray(formData[key])) {
        formData[key].forEach((val, i) => sendData.append(`${key}[${i}]`, val));
      } else {
        sendData.append(key, formData[key]);
      }
    }

    // (formData.main_image || []).forEach((imgObj) => {
    //   sendData.append("main_image[]", imgObj.file);
    // });
    // Append photos correctly
    formData.photos.forEach((item) => {
      if (typeof item === "string") {
        // Old image from database
        sendData.append("photos[]", item);
      } else {
        // New file uploaded
        sendData.append("photos[]", item.file);
      }
    });

    // Debug
    // for (let pair of sendData.entries()) {
    //   console.log(pair[0] + ": ", pair[1]);
    // }

    sendData.append("user_id", user_id);
    if (closingTimeValue) sendData.append("closingTime", closingTimeValue);

    try {
      const res = await fetch(
        `${BASE_URL}/list-item.php?type=websitesavedarft`,
        { method: "POST", body: sendData }
      );

      const rawText = await res.text();
      console.log("Raw Response:", rawText);

      let response;
      try {
        response = JSON.parse(rawText);
      } catch {
        throw new Error("Invalid JSON response: " + rawText);
      }

      if (!response.success) {
        throw new Error(response.message || "Draft save failed");
      }

      setLoading(false);
      await Swal.fire({
        icon: "success",
        title: "💾 Draft Saved!",
        text: response.message || "You can continue editing later 🚀",
        confirmButtonColor: "#28a745",
        timer: 3000,
        timerProgressBar: true,
      });

      toast.success(response.message || "Save Draft Successfully!");
      localStorage.removeItem("listItemData");
      localStorage.removeItem("listItemStep");
      navigate("/");
    } catch (error) {
      console.error("Draft save failed", error);
      Swal.fire("Error", error.message || "Draft could not be saved!", "error");
    } finally {
      setLoading(false);
    }
  };

  const validateStep = () => {
    const errors = {};

    // Closing time required
    if (!formData.closingTime) {
      errors.closingTime = "Please select closing time";
    }

    // Add other field validations here if needed...

    setFormErrors(errors);
    setFormTouched((prev) => ({
      ...prev,
      closingTime: true,
      // Add other fields here as well if needed...
    }));

    return Object.keys(errors).length === 0;
  };

  const handleNext = () => {
    if (validateStep()) {
      setStep(step + 1); // or your next-step logic
    }
  };

  const [loadingSuggestions, setLoadingSuggestions] = useState(false);

  const handleInputChange = async (value) => {
    if (value.length > 0) {
      setLoadingSuggestions(true);
      try {
        const response = await axios.get(`${BASE_URL}/location_search.php`, {
          params: { q: value },
        });

        if (Array.isArray(response.data)) {
          setSuggestions(response.data);
        } else {
          setSuggestions([]);
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setSuggestions([]);
      } finally {
        setLoadingSuggestions(false);
      }
    } else {
      setSuggestions([]);
      setLoadingSuggestions(false);
    }
  };

  const handleSelect = (loc) => {
    // Full formatted location (display_name)
    updateFormData("location", loc.display_name);

    // Try extracting city from address
    const address = loc.address || {};
    const city =
      address.city ||
      address.town ||
      address.village ||
      address.hamlet ||
      address.locality ||
      "";

    updateFormData("city", city);

    setSuggestions([]); // Hide suggestions
  };

  const [category, setcategory] = useState([]);
  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_category.php?t=${Date.now()}`)
      .then((res) => {
        // console.log("Full response:", res.data);
        if (res.data.success && Array.isArray(res.data.data)) {
          setcategory(res.data.data);
          //  console.log("categorysssss", res.data.data);
        } else {
          console.warn("API success true, but data is not array");
          setcategory([]);
        }
      })
      .catch((err) => {
        console.error("Axios error:", err);
        setcategory([]);
      });
  }, []);

  const [locations, setlocation] = useState([]);
  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_location.php?t=${Date.now()}`)
      .then((res) => {
        if (res.data.success && Array.isArray(res.data.data)) {
          //  console.log("All Location:", res.data.data);
          setlocation(res.data.data);
        } else {
          console.warn("API success true, but data is not array");
          setlocation([]);
        }
      })
      .catch((err) => {
        console.error("Axios error:", err);
        setlocation([]);
      });
  }, []);

  const options = locations.map((loc) => ({
    value: loc.city_name,
    label: loc.city_name,
  }));

  const categoryOptions = category.map((cat) => ({
    value: cat.title, // must match your DB/API field
    label: cat.title,
  }));

  const closingTimeOptions = [
    // { value: "1min", label: "1 Minute" },
    // { value: "3min", label: "3 Minutes" },
    // { value: "10min", label: "10 Minutes" },
    // { value: "1", label: "1 Day" },
    { value: "3", label: "3 Days" },
    { value: "5", label: "5 Days" },
    { value: "7", label: "7 Days" },
  ];

  const [acceptTerms, setAcceptTerms] = useState(false);



  const [terms_conditions, setTerms_Condition] = useState("");
  const [terms_conditionsLoader, setTerms_ConditionLoader] = useState("");

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_terms_conditions.php?t=${Date.now()}`)
      .then((res) => {
       // console.log(res);
        setTerms_ConditionLoader(true);
        if (res.data.success) {
          setTerms_Condition(res.data[0]);
          // console.log(res.data.content);
        } else {
          console.error("API response error:", res.data.message);
        }

        setTerms_ConditionLoader(false);
      })
      .catch((err) => console.error("API request failed:", err));
  }, []);
  return (
    <>
      <Navbar />
      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME</p>
                </Link>
                <span>/</span>
                <p>List An item</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="list-item-page">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="progress-container">
                <div className="steps">
                  {[
                    // "Terms & Conditions",
                    "Title & Category",
                    "Pricing & Duration",
                    "Shipping Options",
                    "Add Photos",
                  ].map((label, index) => (
                    <div
                      key={index}
                      className={`step ${step === index + 1 ? "active" : ""}`}
                    >
                      <div className="circle">{index + 1}</div>
                      <p className="label">{label}</p>
                    </div>
                  ))}
                </div>

                <div className="progress-line">
                  <div
                    className="line"
                    style={{ width: `${((step - 1) / 3) * 90}%` }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <br />

          {/* {step === 0 && (
            <div className="row mb-5">
              <div className="col-12" style={{ display: "flex", gap: "10px", alignItems: "center" }}>

                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="green" class="bi bi-shield-fill-check" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.8 11.8 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7 7 0 0 0 1.048-.625 11.8 11.8 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.54 1.54 0 0 0-1.044-1.263 63 63 0 0 0-2.887-.87C9.843.266 8.69 0 8 0m2.146 5.146a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793z" />
                </svg>
                <h2>
                  <b>Terms & Conditions</b>
                </h2>
              </div>

              <div className="col-12 mt-4">
                <div
                  style={{
                    maxHeight: "400px",
                    overflowY: "auto",
                    border: "1px solid #ccc",
                    padding: "15px",
                    borderRadius: "6px",
                    background: "#f9f9f9",
                  }}
                >
                  {terms_conditionsLoader ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-2">Loading terms & conditions...</p>
                    </div>
                  ) : (
                    <div
                      className="row"
                      dangerouslySetInnerHTML={{
                        __html: String(terms_conditions.content),
                      }}
                    />
                  )}
                </div>


                <div className="form-check mt-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="termsCheck"
                    checked={acceptTerms}
                    onChange={(e) => setAcceptTerms(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="termsCheck">
                    I have read and accept the Terms & Conditions
                  </label>
                </div>
              </div>
            </div>
          )} */}


          {/* Step 1 */}
          {step === 1 && (
            <div className="row mb-5">
              <div className="col-12">
                <h2>
                  <b>What are you listing?</b>
                </h2>
              </div>
              <div className="col-12 mt-3">
                <div className="add-detailpage">
                  <div className="forms">
                    <p style={{ marginBottom: "5px" }}>
                      Item Title <span style={{ color: "red" }}>*</span>
                      <span className="tooltip-wrapper">
                        ?{" "}
                        <span className="tooltip-text">
                          Product Title
                        </span>
                      </span>

                    </p>
                    <input
                      type="text"
                      value={formData.title}
                      name="title"
                      onChange={(e) => updateFormData("title", e.target.value)}
                      className={`form-control ${formErrors.title ? "is-invalid" : ""
                        }`}
                    />
                    {formErrors.title && (
                      <div className="invalid-feedback">{formErrors.title}</div>
                    )}
                    <input
                      type="hidden"
                      value={formData.title}
                      onChange={(e) =>
                        updateFormData("user_id", e.target.value)
                      }
                      className="form-control"
                    />
                    <input
                      type="hidden"
                      value={formData.title}
                      onChange={(e) =>
                        updateFormData("username", e.target.value)
                      }
                      className="form-control"
                    />

                    <br />
                    <p style={{ marginBottom: "5px" }}>Categories

                      {" "}
                      <span className="tooltip-wrapper">
                        ?{" "}
                        <span className="tooltip-text">
                          Select Product Categories
                        </span>
                      </span>

                    </p>

                    <Select
                      options={categoryOptions} // 👈 MUST use "options"
                      value={
                        categoryOptions.find(
                          (opt) => opt.value === formData.category
                        ) || null
                      }
                      onChange={(selected) =>
                        updateFormData("category", selected?.value || "")
                      }
                      placeholder="-- Select Categories --"
                      isClearable
                      isSearchable
                      filterOption={(option, inputValue) =>
                        option.label
                          .toLowerCase()
                          .startsWith(inputValue.toLowerCase())
                      }
                    />

                    {formTouched.category ||
                      (formErrors.category && (
                        <div className="invalid-feedback">
                          {formErrors.category}
                        </div>
                      ))}

                    {/* <br />
                    <p>Short Description (Optional)</p>
                    <textarea
                      rows="2"
                      value={formData.shortDesc}
                      onChange={(e) =>
                        updateFormData("shortDesc", e.target.value)
                      }
                      className="form-control"
                      maxLength={150}
                      className={`form-control ${
                        formTouched.shortDesc && formErrors.shortDesc
                          ? "is-invalid"
                          : ""
                      }`}
                    />
                    <p>
                      <b>Note :</b> * Short Description Should not be more than
                      150 characters.
                    </p>

                    {formTouched.shortDesc && formErrors.shortDesc && (
                      <div className="invalid-feedback">
                        {formErrors.shortDesc}
                      </div>
                    )} */}

                    <br />
                    <p>Description (Optional){" "}
                      <span className="tooltip-wrapper">
                        ?{" "}
                        <span className="tooltip-text">
                          Product Description
                        </span>
                      </span>
                    </p>
                    <textarea
                      rows="4"
                      value={formData.desc}
                      onChange={(e) => updateFormData("desc", e.target.value)}
                      className="form-control"
                    // className={`form-control ${
                    //   formTouched.desc && formErrors.desc ? "is-invalid" : ""
                    // }`}
                    />
                    {/* {formTouched.desc && formErrors.desc && (
                      <div className="invalid-feedback">{formErrors.desc}</div>
                    )} */}

                    <br />
                    {/* <p>Quantity (Optional)</p>
                    <input type="text" value={formData.quantity} onChange={(e) => updateFormData("quantity", e.target.value)} className="form-control" /> */}

                    <br />
                    <h2>
                      <b>Item Location</b>
                    </h2>

                    <p>
                      Location <span style={{ color: "red" }}>*</span>
                    </p>
                    <div
                      className={`react-select-wrapper ${formTouched.location && formErrors.location
                        ? "is-invalid"
                        : ""
                        }`}
                    >
                      <Select
                        options={options}
                        value={
                          options.find(
                            (opt) => opt.value === formData.location
                          ) || null
                        }
                        onChange={(selected) => {
                          const value = selected?.value || "";
                          updateFormData("location", value);
                          updateFormData("city", value); // optional
                        }}
                        placeholder="-- Select Location --"
                        isClearable
                        isSearchable
                        filterOption={(option, inputValue) =>
                          option.label
                            .toLowerCase()
                            .startsWith(inputValue.toLowerCase())
                        }
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            borderColor:
                              formTouched.location && formErrors.location
                                ? "red"
                                : state.isFocused
                                  ? "#007bff"
                                  : "#ced4da",
                            boxShadow: state.isFocused
                              ? "0 0 0 0.2rem rgba(0,123,255,.25)"
                              : "none",
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                      />
                    </div>

                    {formTouched.location && formErrors.location && (
                      <div className="invalid-feedback d-block">
                        {formErrors.location}
                      </div>
                    )}

                    <br />
                    <p>Neighborhood (Optional)  {" "}
                      <span className="tooltip-wrapper">
                        ?{" "}
                        <span className="tooltip-text">
                          Right Neighborhood Location
                        </span>
                      </span> </p>
                    <input
                      type="text"
                      value={formData.neighborhood}
                      onChange={(e) =>
                        updateFormData("neighborhood", e.target.value)
                      }
                      className="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Step 2 */}
          {step === 2 && (
            <div className="row mb-5">
              <div className="col-12">
                <h2>
                  <b>Pricing & Duration</b>
                </h2>
              </div>
              <div className="col-12 mt-3">
                <div className="add-detailpage">
                  <div className="forms">
                    <p>
                      Listing Type <span style={{ color: "red" }}>*</span>  <span className="tooltip-wrapper">
                        ?{" "}
                        <span className="tooltip-text">
                          Select Product Listing Types
                        </span>
                      </span>
                    </p>

                    <div className="form-check mt-3">
                      <input
                        id="listingTypeAuction"
                        className="form-check-input"
                        type="radio"
                        name="listingType"
                        value="OnlyAuction"
                        checked={formData.listingType === "OnlyAuction"}
                        onChange={(e) => {
                          updateFormData("listingType", e.target.value);
                          setFormTouched((prev) => ({
                            ...prev,
                            listingType: true,
                          }));
                        }}
                      />
                      <label
                        htmlFor="listingTypeAuction"
                        className="form-check-label"
                      >
                        Auction
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        id="listingTypeAuctionBuy"
                        className="form-check-input"
                        type="radio"
                        name="listingType"
                        value="Auctionwithbuy"
                        checked={formData.listingType === "Auctionwithbuy"}
                        onChange={(e) => {
                          updateFormData("listingType", e.target.value);
                          setFormTouched((prev) => ({
                            ...prev,
                            listingType: true,
                          }));
                        }}
                      />
                      <label
                        htmlFor="listingTypeAuctionBuy"
                        className="form-check-label"
                      >
                        Auction & Buy Now
                      </label>
                    </div>

                    {formTouched.listingType && formErrors.listingType && (
                      <div className="invalid-feedback d-block">
                        {formErrors.listingType}
                      </div>
                    )}

                    <br />

                    <p>
                      Product Type <span style={{ color: "red" }}>*</span> <span className="tooltip-wrapper">
                        ?{" "}
                        <span className="tooltip-text">
                          Select Product Types
                        </span>
                      </span>
                    </p>

                    <div className="form-check mt-3">
                      <input
                        id="productTypeUsed"
                        className="form-check-input"
                        type="radio"
                        name="productType"
                        value="used"
                        checked={formData.productType === "used"}
                        onChange={(e) =>
                          updateFormData("productType", e.target.value)
                        }
                      />
                      <label
                        htmlFor="productTypeUsed"
                        className="form-check-label"
                      >
                        Used
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        id="productTypeNotUsed"
                        className="form-check-input"
                        type="radio"
                        name="productType"
                        value="notused"
                        checked={formData.productType === "notused"}
                        onChange={(e) =>
                          updateFormData("productType", e.target.value)
                        }
                      />
                      <label
                        htmlFor="productTypeNotUsed"
                        className="form-check-label"
                      >
                        Not Used
                      </label>
                    </div>

                    {formTouched.productType && formErrors.productType && (
                      <div className="invalid-feedback d-block">
                        {formErrors.productType}
                      </div>
                    )}

                    <br />

                    {formData.productType === "used" && (
                      <>
                        <br />
                        <p>Use Description </p>
                        <textarea
                          rows="4"
                          value={formData.useproductDes}
                          onChange={(e) =>
                            updateFormData("useproductDes", e.target.value)
                          }
                          className="form-control"
                        ></textarea>

                        {formTouched.useproductDes &&
                          formErrors.useproductDes && (
                            <div className="invalid-feedback d-block">
                              {formErrors.useproductDes}
                            </div>
                          )}
                      </>
                    )}

                    <br />
                    <p>Auction Start Price (optional) <span className="tooltip-wrapper">
                      ?{" "}
                      <span className="tooltip-text">
                        The least price you think you can accept
                      </span>
                    </span></p>
                    <input
                      type="number"
                      value={formData.auctionStartPrice}
                      name="auctionStartPrice"
                      onChange={(e) => {
                        const value = e.target.value;
                        // Only allow positive integers (no 0, no decimal)
                        if (/^\d+$/.test(value) && parseInt(value) > 0) {
                          updateFormData("auctionStartPrice", e.target.value);
                        } else if (value === "") {
                          updateFormData("auctionStartPrice", "");
                        }
                      }}
                      min="0"
                      step="0"
                      // className="form-control"
                      className={`form-control ${formTouched.auctionStartPrice &&
                        formErrors.auctionStartPrice
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                    {formTouched.auctionStartPrice &&
                      formErrors.auctionStartPrice && (
                        <div className="invalid-feedback">
                          {formErrors.auctionStartPrice}
                        </div>
                      )}

                    <br />
                    <p>
                      Desired Price (optional){" "}
                      <span className="tooltip-wrapper">
                        ?{" "}
                        <span className="tooltip-text">
                          The least price you think you can accept
                        </span>
                      </span>
                    </p>
                    <input
                      type="number"
                      name="desiredPrice"
                      value={formData.desiredPrice}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Only allow positive integers (no 0, no decimal)
                        if (/^\d+$/.test(value) && parseInt(value) > 0) {
                          updateFormData("desiredPrice", e.target.value);
                        } else if (value === "") {
                          updateFormData("desiredPrice", "");
                        }
                      }}
                      min="0"
                      step="0"
                      className={`form-control ${formTouched.desiredPrice && formErrors.desiredPrice
                        ? "is-invalid"
                        : ""
                        }`}
                    />
                    {formTouched.desiredPrice && formErrors.desiredPrice && (
                      <div className="invalid-feedback">
                        {formErrors.desiredPrice}
                      </div>
                    )}
                    <p>
                      <b>Note :</b> This price is not visible to the buyer.
                    </p>

                    <br />

                    {formData.listingType === "Auctionwithbuy" && (
                      <>
                        <p>
                          Buy Now <span style={{ color: "red" }}>*</span>
                        </p>
                        <input
                          type="number"
                          value={formData.buyNow}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Only allow positive integers (no 0, no decimal)
                            if (/^\d+$/.test(value) && parseInt(value) > 0) {
                              updateFormData("buyNow", e.target.value);
                            } else if (value === "") {
                              updateFormData("buyNow", "");
                            }
                          }}
                          min="1"
                          step="1"
                          className={`form-control ${formTouched.buyNow && formErrors.buyNow
                            ? "is-invalid"
                            : ""
                            }`}
                        />
                        {formTouched.buyNow && formErrors.buyNow && (
                          <div className="invalid-feedback">
                            {formErrors.buyNow}
                          </div>
                        )}
                        <p>
                          <b>Note :</b> The product price becomes hidden when
                          the current bid reaches or exceeds 80% of the base
                          price.
                        </p>
                      </>
                    )}

                    <br />
                    {sessionuser?.membership_type === "Silver" ||
                      sessionuser?.membership_type === "Gold" ? (
                      " "
                    ) : (
                      <>
                        <p>
                          Closing Time <span style={{ color: "red" }}>*</span> {" "}
                          <span className="tooltip-wrapper">
                            ?{" "}
                            <span className="tooltip-text">
                              Set Product Closing Time
                            </span>
                          </span>
                        </p>
                        <div
                          className={`react-select-wrapper ${formTouched.closingTime && formErrors.closingTime
                            ? "is-invalid"
                            : ""
                            }`}
                        >
                          <Select
                            options={closingTimeOptions}
                            value={
                              closingTimeOptions.find(
                                (opt) => opt.value === formData.closingTime
                              ) || null
                            }
                            onChange={(selected) => {
                              updateFormData(
                                "closingTime",
                                selected?.value || ""
                              );
                              updateFormData(
                                "closingTimeword",
                                selected?.value || ""
                              );
                            }}
                            placeholder="-- Select Closing Time --"
                            isClearable
                            isSearchable
                            styles={{
                              control: (base, state) => ({
                                ...base,
                                borderColor:
                                  formTouched.closingTime &&
                                    formErrors.closingTime
                                    ? "red" // 🔴 show validation error
                                    : state.isFocused
                                      ? "#007bff"
                                      : "#ced4da",
                                boxShadow: state.isFocused
                                  ? "0 0 0 0.2rem rgba(0,123,255,.25)"
                                  : "none",
                                "&:hover": {
                                  borderColor:
                                    formTouched.closingTime &&
                                      formErrors.closingTime
                                      ? "red"
                                      : "#007bff",
                                },
                              }),
                            }}
                          />
                        </div>

                        {formTouched.closingTime && formErrors.closingTime && (
                          <div className="invalid-feedback d-block">
                            {formErrors.closingTime}
                          </div>
                        )}
                      </>
                    )}

                    <br />
                    <p>
                      Specified end time:{" "}

                      <span>
                        <Link to="/membership" className="premium-link">
                          (Premium Feature){" "}
                        </Link>
                      </span>
                      {" "}
                      <span className="tooltip-wrapper">
                        ?{" "}
                        <span className="tooltip-text">
                          Set Product Closing Time
                        </span>
                      </span>
                    </p>
                    {sessionuser?.membership_type === "Silver" ||
                      sessionuser?.membership_type === "Gold" ? (
                      <>
                        <input
                          type="datetime-local"
                          className={`form-control ${formTouched.closingTime && formErrors.closingTime
                            ? "is-invalid"
                            : ""
                            }`}
                          style={{ color: "#000" }}
                          value={
                            formData.closingTime
                              ? formData.closingTime.replace(" ", "T")
                              : "" // << safe fallback
                          }
                          onChange={(e) => {
                            const datetime = e.target.value;
                            updateFormData(
                              "closingTime",
                              datetime.replace("T", " ")
                            );
                          }}
                          min={(() => {
                            const minDate = new Date();
                            minDate.setDate(minDate.getDate() + 3); // 🔥 2 days ahead
                            minDate.setHours(0, 0, 0, 0);
                            return minDate.toISOString().slice(0, 16);
                          })()}
                          style={{ color: "black" }}
                        />

                        {formTouched.closingTime && formErrors.closingTime && (
                          <div className="invalid-feedback d-block">
                            {formErrors.closingTime}
                          </div>
                        )}
                      </>
                    ) : (
                      <input type="date" disabled className="form-control" />
                    )}

                    <p>
                      Specified end time is a{" "}
                      <b style={{ color: "#f6cb6e" }}>Premium Member feature</b>{" "}
                      , unlock all features by{" "}
                      <Link to="/membership" className="premium-link">
                        Upgrading Now!{" "}
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Step 3 */}
          {step === 3 && (
            <div className="row mb-5 forms">
              <div className="col-12">
                <h2>
                  <b>Shipping Options {"(Optional)"}</b>
                </h2>
              </div>
              <div className="form-check mt-3">
                <input
                  id="shippingYes"
                  className={`form-check-input ${formTouched.shipping && formErrors.shipping
                    ? "is-invalid"
                    : ""
                    }`}
                  type="radio"
                  name="shipping"
                  value="Yes"
                  checked={formData.shipping === "Yes"}
                  onChange={(e) => {
                    updateFormData("shipping", e.target.value);
                    setFormTouched((prev) => ({ ...prev, shipping: true }));
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor="shippingYes"
                  style={{ margin: " 2px 0 5px" }}
                >
                  Shipping available
                </label>
              </div>

              <div className="form-check">
                <input
                  id="shippingNo"
                  className={`form-check-input ${formTouched.shipping && formErrors.shipping
                    ? "is-invalid"
                    : ""
                    }`}
                  type="radio"
                  name="shipping"
                  value="No"
                  checked={formData.shipping === "No"}
                  onChange={(e) => {
                    updateFormData("shipping", e.target.value);
                    setFormTouched((prev) => ({ ...prev, shipping: true }));
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor="shippingNo"
                  style={{ margin: " 2px 0 5px" }}
                >
                  No shipping
                </label>
              </div>

              {/* {formData.shipping === "Yes" && (
                <>
                  <div style={{ marginTop: "10px" }}>
                    <input
                      type="text"
                      value={formData.shippingCity}
                      onChange={(e) =>
                        updateFormData("shippingCity", e.target.value)
                      }
                      placeholder="Shipping With in City"
                      className={`form-control ${
                        formErrors.shippingCity ? "is-invalid" : ""
                      }`}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    <input
                      type="number"
                      value={formData.shippingCost}
                      onChange={(e) =>
                        updateFormData("shippingCost", e.target.value)
                      }
                      className={`form-control ${
                        formErrors.shippingCost ? "is-invalid" : ""
                      }`}
                      placeholder="Cost : 20 SAR"
                    />

                    <div
                      className="form-check"
                      style={{
                        width: "30%",
                        border: "1px solid #dee2e6",
                        borderRadius: "5px",
                        padding: "10px 35px",
                      }}
                    >
                      <input
                        id="shippingFree"
                        className={`form-check-input ${
                          formTouched.freeshipping && formErrors.freeshipping
                            ? "is-invalid"
                            : ""
                        }`}
                        type="radio"
                        name="shippingFree"
                        value="Yes"
                        checked={formData.freeshipping === "Yes"}
                        onChange={(e) => {
                          updateFormData("freeshipping", e.target.value);
                          setFormTouched((prev) => ({
                            ...prev,
                            shipping: true,
                          }));
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="shippingFree"
                        style={{ margin: " 2px 0 5px" }}
                      >
                        Free shipping
                      </label>
                    </div>
                  </div>

                  <div style={{ marginBottom: "10px" }}>
                    <textarea
                      rows="4"
                      value={formData.sheppingDes}
                      onChange={(e) =>
                        updateFormData("sheppingDes", e.target.value)
                      }
                      className="form-control"
                      placeholder="Description (Optional)"
                    ></textarea>
                  </div>
                </>
              )} */}

              {formTouched.shipping && formErrors.shipping && (
                <div className="invalid-feedback d-block">
                  {formErrors.shipping}
                </div>
              )}

              <p>Shipping options depend on user plan.</p>
            </div>
          )}

          {/* Step 4 */}
          {step === 4 && (
            <div className="row mb-5">
              <div className="col-12">
                <h2>
                  <b>Add Photos</b>
                </h2>
              </div>

              <div className="col-12 mt-3">
                <div className="add-detailpage">
                  <div className="forms">
                    <div>
                      {/* DRAG AREA */}
                      <div
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => {
                          e.preventDefault();
                          handleFiles(e.dataTransfer.files);
                        }}
                        className="border-2 border-dashed p-5 rounded text-center cursor-pointer"
                        onClick={() =>
                          document.getElementById("file-gallery").click()
                        }
                        style={{
                          border: "1px dashed #00b1db",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column"
                        }}
                      >
                        <img
                          src={`/logo/upload.png`}
                          alt="Upload Image"
                          width={100}
                        />
                        <p style={{ fontWeight: "800" }}>
                          Drag & Drop images here
                          <br />
                          or
                          <br />
                          Click to Upload
                        </p>
                      </div>

                      {/* FILE INPUT (hidden) */}
                      <input
                        type="file"
                        id="file-gallery"
                        className="hidden"
                        accept="image/*"
                        multiple
                        onChange={(e) => {
                          handleFiles(e.target.files);
                          e.target.value = ""; // allow reselect
                        }}
                        style={{ display: "none" }}
                      />
                    </div>

                    {/* Preview section */}
                  </div>
                  <div style={{ overflow: "hidden" }}>
                    {imagelodaer && (
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          background: "rgba(255,255,255,0.7)",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          zIndex: 9999,
                        }}
                      >
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                    <DragDropContext onDragEnd={handleDragEnd}>
                      <Droppable droppableId="images" direction="horizontal">
                        {(provided) => (
                          <div
                            className="row mt-3"
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                          >
                            {formData.photos?.map((src, index) => (
                              <Draggable
                                key={index}
                                draggableId={index.toString()}
                                index={index}
                              >
                                {(provided) => (
                                  <div
                                    className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 mb-3"
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                  >
                                    <div className="position-relative">
                                      {index === 0 && (
                                        <span
                                          className="badge bg-warning text-dark position-absolute"
                                          style={{
                                            top: "5px",
                                            left: "5px",
                                            fontSize: "12px",
                                            padding: "3px 6px",
                                            borderRadius: "5px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          Main Image
                                        </span>
                                      )}
                                      <img
                                        src={src.preview}
                                        alt={`preview-${index}`}
                                        className="img-fluid rounded"
                                        style={{
                                          height: "150px",
                                          objectFit: "contain",
                                          width: "100%",
                                          border:
                                            index === 0
                                              ? "3px solid gold"
                                              : "1px solid #ccc",
                                        }}
                                      />
                                      <button
                                        type="button"
                                        onClick={() => removeImage(index)}
                                        className="btn btn-sm btn-danger position-absolute"
                                        style={{ top: 5, right: 5 }}
                                      >
                                        &times;
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </div>

                  <br />
                  <p>
                    <b>NOTE :</b> <br />
                    * Desired price will mot be visible to the buyer.
                    <br />
                    * Item in the draft will be removed after 7 days. <br />
                    * Once an auction is placed it cannot be deleted if anyone
                    has placed a bid or clicked buy now. <br />* The buy now
                    button will disappear when the bid reaches 80% more of the
                    buy now price.
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Navigation Buttons */}
          <div className="row mb-5">
            <div className="col-12 mt-4 gap-2">
              <button
                onClick={handleSaveDraft}
                className="Next"
                style={{ backgroundColor: "#939393" }}
              >
                Save as Draft
              </button>
              {step > 1 && (
                <button
                  onClick={prevStep}
                  className="Next"
                  style={{ backgroundColor: "#ffbf00", color: "black" }}
                >
                  Previous
                </button>
              )}
              {step < 4 ? (
                <button onClick={nextStep} className="Next">
                  Next
                </button>
              ) : (
                <button
                  onClick={handleSubmit}
                  className="Next"
                  disabled={imagelodaer}
                >
                  Submit
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Loading Overlay */}
      {loading && (
        <div
          className="loading-overlay"
          style={{
            position: "fixed",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100%",
            top: "0",
            zIndex: "999999",
            background: "##0000003d",
          }}
        >
          <div className="dot-spinner">
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
          </div>
        </div>
      )}
      <Fotter />
      <ToastContainer />
    </>
  );
}
